module.exports = __webpack_public_path__ + "media/styles/images/png/circle-plus-white-9048382460acd1d2f839561af203d4d9.png";